import React, { useRef, useState } from "react";
import {
  MiniNewsWidget,
  MiniNewsWidgetProps,
  ThemeType,
  WidgetError,
  WidgetMessage,
  WidgetHeightMessage,
  WidgetNameSource,
} from "@labci/bell-fg-widgets";
import { Spin } from "antd";
import CircularProgress from "../Components/CircularProgress/CircularProgress";
import { useOverscrollGesture } from "../hooks/useOverscrollGesture";

const Newswidget: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true);

  const queryParams = new URLSearchParams(window.location.search);
  const rics = queryParams.get("rics") || "";
  const symbol = queryParams.get("symbol") || "";
  const token = queryParams.get("token") || "";
  const theme = queryParams.get("theme") || ThemeType.Direct;

  const handleNoData = (message: WidgetMessage) => {
    console.log("handleNoData", message);
    if ((window as any).ReactNativeWebView) {
      (window as any).ReactNativeWebView.postMessage(JSON.stringify(message));
      return;
    }
    window.parent.postMessage(JSON.stringify(message), "*");
  };

  const handleError = (error: WidgetError) => {
    console.log("handleError", error);
    if ((window as any).ReactNativeWebView) {
      (window as any).ReactNativeWebView.postMessage(JSON.stringify(error));
      return;
    }
    window.parent.postMessage(JSON.stringify(error), "*");
  };

  const handleLoadingChange = (loading: boolean) => {
    setIsLoading(loading);

    const loadingMessage = {
      type: "loading",
      value: loading,
      source: WidgetNameSource.MiniNews,
    };
    if ((window as any).ReactNativeWebView) {
      (window as any).ReactNativeWebView.postMessage(
        JSON.stringify(loadingMessage),
      );
      return;
    }
    window.parent.postMessage(JSON.stringify(loadingMessage), "*");
  };

  const handleHeightChange = (messages: WidgetHeightMessage) => {
    console.log("handleHeightChange", messages);
    if ((window as any).ReactNativeWebView) {
      (window as any).ReactNativeWebView.postMessage(JSON.stringify(messages));
      return;
    }
    window.parent.postMessage(JSON.stringify(messages), "*");
  };

  const props: MiniNewsWidgetProps = {
    rics: rics,
    symbol: symbol,
    token: token,
    onError: handleError,
    onNoData: handleNoData,
    onLoadingChange: handleLoadingChange,
    theme: theme as ThemeType,
    onHeightChange: handleHeightChange,
  };

  const containerRef = useRef<HTMLDivElement>(null);
  useOverscrollGesture(containerRef);

  return (
    <div ref={containerRef}>
      <Spin
        wrapperClassName="widget-spin"
        spinning={isLoading}
        indicator={<CircularProgress theme={theme as ThemeType} />}
      >
        <MiniNewsWidget {...props} />
      </Spin>
    </div>
  );
};

export default Newswidget;
